import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface CurrencySelectProps {
  currency: string;
  onCurrencyChange: (value: string) => void;
}

export const CurrencySelect = ({ currency, onCurrencyChange }: CurrencySelectProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="currencySelect">Default Currency</Label>
      <Select 
        value={currency} 
        onValueChange={onCurrencyChange}
      >
        <SelectTrigger id="currencySelect" className="w-full">
          <SelectValue placeholder="Select currency" />
        </SelectTrigger>
        <SelectContent className="max-h-[300px] overflow-y-auto">
          <SelectGroup>
            <SelectLabel>African Currencies</SelectLabel>
            <SelectItem value="KES">KES (Kenyan Shilling)</SelectItem>
            <SelectItem value="ETB">ETB (Ethiopian Birr)</SelectItem>
            <SelectItem value="NGN">NGN (Nigerian Naira)</SelectItem>
            <SelectItem value="ZAR">ZAR (South African Rand)</SelectItem>
            <SelectItem value="GHS">GHS (Ghanaian Cedi)</SelectItem>
            <SelectItem value="TZS">TZS (Tanzanian Shilling)</SelectItem>
            <SelectItem value="RWF">RWF (Rwandan Franc)</SelectItem>
            <SelectItem value="UGX">UGX (Ugandan Shilling)</SelectItem>
            <SelectItem value="XOF">XOF (West African CFA Franc)</SelectItem>
            <SelectItem value="DZD">DZD (Algerian Dinar)</SelectItem>
            <SelectItem value="AOA">AOA (Angolan Kwanza)</SelectItem>
            <SelectItem value="BWP">BWP (Botswanan Pula)</SelectItem>
            <SelectItem value="BIF">BIF (Burundian Franc)</SelectItem>
            <SelectItem value="CVE">CVE (Cape Verdean Escudo)</SelectItem>
            <SelectItem value="XAF">XAF (Central African CFA Franc)</SelectItem>
            <SelectItem value="KMF">KMF (Comorian Franc)</SelectItem>
            <SelectItem value="CDF">CDF (Congolese Franc)</SelectItem>
            <SelectItem value="DJF">DJF (Djiboutian Franc)</SelectItem>
            <SelectItem value="EGP">EGP (Egyptian Pound)</SelectItem>
            <SelectItem value="ERN">ERN (Eritrean Nakfa)</SelectItem>
            <SelectItem value="SZL">SZL (Swazi Lilangeni)</SelectItem>
            <SelectItem value="GMD">GMD (Gambian Dalasi)</SelectItem>
            <SelectItem value="GNF">GNF (Guinean Franc)</SelectItem>
            <SelectItem value="LSL">LSL (Lesotho Loti)</SelectItem>
            <SelectItem value="LRD">LRD (Liberian Dollar)</SelectItem>
            <SelectItem value="LYD">LYD (Libyan Dinar)</SelectItem>
            <SelectItem value="MGA">MGA (Malagasy Ariary)</SelectItem>
            <SelectItem value="MWK">MWK (Malawian Kwacha)</SelectItem>
            <SelectItem value="MRU">MRU (Mauritanian Ouguiya)</SelectItem>
            <SelectItem value="MUR">MUR (Mauritian Rupee)</SelectItem>
            <SelectItem value="MAD">MAD (Moroccan Dirham)</SelectItem>
            <SelectItem value="MZN">MZN (Mozambican Metical)</SelectItem>
            <SelectItem value="NAD">NAD (Namibian Dollar)</SelectItem>
            <SelectItem value="STN">STN (São Tomé and Príncipe Dobra)</SelectItem>
            <SelectItem value="SCR">SCR (Seychellois Rupee)</SelectItem>
            <SelectItem value="SLL">SLL (Sierra Leonean Leone)</SelectItem>
            <SelectItem value="SOS">SOS (Somali Shilling)</SelectItem>
            <SelectItem value="SSP">SSP (South Sudanese Pound)</SelectItem>
            <SelectItem value="SDG">SDG (Sudanese Pound)</SelectItem>
            <SelectItem value="TND">TND (Tunisian Dinar)</SelectItem>
            <SelectItem value="ZMW">ZMW (Zambian Kwacha)</SelectItem>
            <SelectItem value="ZWL">ZWL (Zimbabwean Dollar)</SelectItem>
          </SelectGroup>
          <SelectGroup>
            <SelectLabel>Global Currencies</SelectLabel>
            <SelectItem value="USD">USD (US Dollar)</SelectItem>
            <SelectItem value="EUR">EUR (Euro)</SelectItem>
            <SelectItem value="GBP">GBP (British Pound)</SelectItem>
            <SelectItem value="CAD">CAD (Canadian Dollar)</SelectItem>
            <SelectItem value="AUD">AUD (Australian Dollar)</SelectItem>
            <SelectItem value="JPY">JPY (Japanese Yen)</SelectItem>
            <SelectItem value="CHF">CHF (Swiss Franc)</SelectItem>
            <SelectItem value="CNY">CNY (Chinese Yuan)</SelectItem>
            <SelectItem value="INR">INR (Indian Rupee)</SelectItem>
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
